import {MaterialModule} from '../material/material.module';
import {NgModule} from '@angular/core';
import {CalculationFieldComponent} from './components/calculation-field/calculation-field.component';
import {CheckboxFieldComponent} from './components/checkbox-field/checkbox-field.component';
import {DateFieldComponent} from './components/date-field/date-field.component';
import {DecimalFieldComponent} from './components/decimal-field/decimal-field.component';
import {FieldComponent} from './components/field/field.component';
import {IntegerFieldComponent} from './components/integer-field/integer-field.component';
import {SelectFieldComponent} from './components/select-field/select-field.component';
import {TextFieldComponent} from './components/text-field/text-field.component';
import {TimestampFieldComponent} from './components/timestamp-field/timestamp-field.component';
import {YesNoFieldComponent} from './components/yes-no-field/yes-no-field.component';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {DateFieldService} from './services/date-field/date-field.service';
import {SelectFieldService} from './services/select-field/select-field.service';
import {TimestampValidatorDirective} from './components/timestamp-field/timestamp-validator.directive';
import {TextMaskModule} from 'angular2-text-mask';
import { ExceptionFieldComponent } from './components/exception-field/exception-field.component';
import { DefaultReadonlyFieldComponent } from './components/default-readonly-field/default-readonly-field.component';
import { FieldValueDirective } from './directives/field-value.directive';
import {FieldFormService} from './services/field-form/field-form.service';
import {FieldValueService} from './services/field-value/field-value.service';
import {SentryModule} from '../utilities/modules/sentry/sentry.module';

const FieldComponents = [
  CalculationFieldComponent,
  CheckboxFieldComponent,
  DateFieldComponent,
  DecimalFieldComponent,
  FieldComponent,
  IntegerFieldComponent,
  SelectFieldComponent,
  TextFieldComponent,
  TimestampFieldComponent,
  YesNoFieldComponent,
  ExceptionFieldComponent,
  DefaultReadonlyFieldComponent,
  ExceptionFieldComponent
];

@NgModule({
  declarations: [
    ...FieldComponents,
    TimestampValidatorDirective,
    FieldValueDirective
  ],
  entryComponents: [
    ...FieldComponents
  ],
  imports: [
    MaterialModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TextMaskModule,
    SentryModule
  ],
  exports: [
    CalculationFieldComponent,
    CheckboxFieldComponent,
    DateFieldComponent,
    DecimalFieldComponent,
    ExceptionFieldComponent,
    FieldComponent,
    IntegerFieldComponent,
    SelectFieldComponent,
    TextFieldComponent,
    TimestampFieldComponent,
    YesNoFieldComponent
  ],
  providers: [
    DateFieldService,
    SelectFieldService,
    FieldFormService,
    FieldValueService,
  ]
})
export class FieldsModule { }



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/fields/fields.module.ts